// extracted by mini-css-extract-plugin
module.exports = {"hiddenArrow":"style_hiddenArrow__EW_vi"};